"use client";

import { useEffect, useState } from "react";
import { ChevronLeft, Headset } from "lucide-react";
import Accordion from "@/components/ui/accordion";
import Button from "@/components/ui/button";
import Title from "@/components/Title";

export const FAQ_ANCHOR = "seller-academy-faq";

const Faq = ({ fields }) => {
    const [openId, setOpenId] = useState(null);

    const items = (fields?.repeatable_fields || []).filter((item) => item?.question);

    useEffect(() => {
        if (!items?.length) return;
        if (window.location.hash !== `#${FAQ_ANCHOR}`) return;

        const timer = setTimeout(() => {
            document
                .getElementById(FAQ_ANCHOR)
                ?.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 400);

        return () => clearTimeout(timer);
    }, [items?.length]);

    if (!items?.length) return null;

    const cta_href = fields?.cta_button_link?.url || fields?.cta_button_link || "";

    return (
        <section
            id={FAQ_ANCHOR}
            className="container scroll-mt-[calc(var(--header-height,64px)+16px)]">

            {fields?.section_title?.title && (
                <div className="mb-4 flex items-center gap-2 text-jmt-main lg:mb-6">
                    {fields?.icon && (
                        <span
                            className="flex h-6 w-6 items-center justify-center text-jmt-primary-800 [&>svg]:h-6 [&>svg]:w-6"
                            dangerouslySetInnerHTML={{ __html: fields.icon }}
                        />
                    )}
                    <Title
                        type={fields?.section_title?.type}
                        className="text-base font-bold lg:text-xl">
                        {fields?.section_title?.title}
                    </Title>
                </div>
            )}

            <div className={`flex flex-col ${fields?.section_title?.title && fields?.icon ? "lg:pr-8" : ""}`}>
                {items.map((item, index) => (
                    <Accordion
                        key={item?.id || index}
                        className="w-full border-b border-jmt-neutral-200"
                        iconClassname="text-jmt-main"
                        headerClassName="flex w-full items-center justify-between gap-4"
                        title={
                            <span className="block w-full py-4 text-right text-sm font-bold text-jmt-main lg:text-base">
                                {item?.question}
                            </span>
                        }
                        isOpen={openId === (item?.id || index)}
                        onToggle={(next) => setOpenId(next ? item?.id || index : null)}>

                        <div
                            className="editor-content pb-4 text-right text-sm leading-7 text-jmt-neutral-600 [&_a]:font-bold [&_a]:text-jmt-primary-800 [&_p]:m-0"
                            dangerouslySetInnerHTML={{ __html: item?.answer || "" }}
                        />
                    </Accordion>
                ))}
            </div>

            {fields?.cta_text && (
                <div className="mt-6 flex flex-wrap items-center justify-center gap-4 rounded-md bg-jmt-neutral-100 p-4 lg:gap-6">
                    <div className="flex items-center gap-2 text-jmt-main">
                        <Headset className="h-5 w-5 shrink-0 lg:h-6 lg:w-6" />
                        <span className="text-xs font-bold lg:text-sm">
                            {fields?.cta_text}
                        </span>
                    </div>

                    {cta_href && (
                        <Button
                            href={cta_href}
                            color_type="primary"
                            text={fields?.cta_button_text || "تماس با ما"}
                            end_icon={<ChevronLeft size={18} />}
                            className="shrink-0 w-1/2 md:w-fit"
                        />
                    )}
                </div>
            )}
        </section>
    );
};

export default Faq;
